module.exports = __webpack_public_path__ + "media/scholarship_winners/lindy-sw-ae909253.png";